import Vue from 'vue';
// import { Message, MessageBox } from 'element-ui';
import _ from 'lodash';
import {
    GET_ENTER_STORE_LIST_REQUEST,
    GET_ENTER_STORE_LIST_SUCCESS,
    GET_ENTER_STORE_LIST_FAILURE,
    UPDATE_ENTER_STORE_LIST_PARAMS,
    RESET_ENTER_STORE_LIST,
    RESOLVE_ENTER_STORE_LIST_PARAMS,
} from '../mutationTypes';

const state = {
    loading: false,
    page: 1,
    pagesize: 20,
    goodsName: '',
    barCode: '',
    enterStoreStatus: 0, // 出库方式
    startEndDate: [], // 组件返回形式为数组, 请求时分开提交
    listData: [],
    pageCount: 1,
    reqParams: {},
};

const mutations = {
    [GET_ENTER_STORE_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_ENTER_STORE_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count;
        state.listData = res.listData;
    },
    [GET_ENTER_STORE_LIST_FAILURE](state) {
        state.loading = false;
        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_ENTER_STORE_LIST_PARAMS](state, params) {
        const { page } = params;
        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
        state[Object.keys(params)[0]] = params[Object.keys(params)[0]];
    },
    [RESET_ENTER_STORE_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            page: 1,
            pagesize: 20,
            goodsName: '',
            barCode:'',
            enterStoreStatus:0,
            startEndDate: [],
            listData: [],
            pageCount: 1,
            reqParams: {}
        }));
    },
    [RESOLVE_ENTER_STORE_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getEnterStoreList({ commit }) {
        commit(GET_ENTER_STORE_LIST_REQUEST);
        const res = await Vue.$ajax.get('inboundRecord', state.reqParams);
        if (!res.errorType) {
            commit(GET_ENTER_STORE_LIST_SUCCESS, res);
        } else {
            commit(GET_ENTER_STORE_LIST_FAILURE);
        }
    },
    resolveEnterStoreListParams({ commit }) {
        let params = _.pick(state, ['goodsName', 'barCode', 'enterStoreStatus',
            'page', 'pagesize']);

        params = Object.assign({}, params, {
            startDate: state.startEndDate.length ? state.startEndDate[0] : null,
            endDate: state.startEndDate.length ? state.startEndDate[1] : null
        });
        commit(RESOLVE_ENTER_STORE_LIST_PARAMS, params);
    },
    resetEnterStoreList({ commit }) {
        commit(RESET_ENTER_STORE_LIST);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/enterStore.js